<div class="row w-100 m-0">
  <div class="col-lg-12 layout-spacing">
    <div class="mb-4">
      <div class="widget-content widget-content-area">
        <div class="w-100">
          <div class="form-group row">
            <h5>{{ 'companies.license.license' | translate }}</h5>
          </div>
          <form class="form-grid" [formGroup]="licenseForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label>{{ 'companies.license.licenseName' | translate }} <span class="required">*</span></label>
                <input type="text" formControlName="license" class="form-control" />
            </div>
            <div class="form-group">
                <label>{{ 'companies.license.licenseQty' | translate }} <span class="required">*</span></label>
                <input type="number" formControlName="licenseQty" class="form-control" />
            </div>
            <div class="form-group">
                <label>{{ 'companies.license.beginningDate' | translate }} <span class="required">*</span></label>
                <input
                    bsDatepicker
                    class="form-control flatpickr flatpickr-input active"
                    placeholder="Selecione una fecha"
                    [bsConfig]="{ isAnimated: true, containerClass: 'theme-dark-blue' , dateInputFormat: 'DD-MM-YYYY'}"
                    [maxDate]="licenseForm.controls.endingDate.value" 
                    type="text" 
                    formControlName="beginningDate" 
                    class="form-control"
                />
            </div>
            <div class="form-group">
                <label>{{ 'companies.license.endingDate' | translate }} <span class="required">*</span></label>
                <input
                    bsDatepicker
                    class="form-control flatpickr flatpickr-input active"
                    placeholder="Selecione una fecha"
                    [bsConfig]="{ isAnimated: true, containerClass: 'theme-dark-blue' , dateInputFormat: 'DD-MM-YYYY'}"
                    [minDate]="licenseForm.controls.beginningDate.value"
                    type="text" 
                    formControlName="endingDate" 
                    class="form-control" 
                />
            </div>
            <div class="form-group">
                <label>{{ 'companies.license.comercialName' | translate }} <span class="required">*</span></label>
                <input type="text" formControlName="comercialName" class="form-control" />
            </div>
            <div class="form-group">
                <label>{{ 'companies.license.comercialEmail' | translate }} <span class="required">*</span></label>
                <input type="text" formControlName="comercialEmail" class="form-control" />
            </div>
            <div class="form-group">
                <label>{{ 'companies.license.code' | translate }}</label>
                <input type="text" formControlName="code" class="form-control" />
            </div>
            <div class="form-submit">
                <button
                  class="btn btn-sm btn-primary"
                  type="submit"
                  [disabled]="!licenseForm.valid"
                >
                  {{ 'submit' | translate}}
                </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
